import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-required-indicator',
    templateUrl: './required-indicator.component.html',
    styleUrls: ['./required-indicator.component.scss'],
    standalone: false
})

export class RequiredIndicatorComponent {
  private _required = false;
  private _inverted = false;

  @Input()
  get required(): boolean {
    return this._required;
  }

  set required(value: boolean) {
    this._required = typeof value !== 'undefined' && value !== false;
  }

  @Input()
  get inverted(): boolean {
    return this._inverted;
  }

  set inverted(value: boolean) {
    this._inverted = typeof value !== 'undefined' && value !== false;
  }

  @Input() ariaHidden: boolean | null = null;
}
